import React, { useState } from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';
import Image from '../elements/Image';
import Modal from '../elements/Modal';
import { Link } from 'react-router-dom';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  }   

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const bannerPhrases = [
    "It's not rocket science",
    "Jumping the Gun",
    "Put a Sock In It",
    "Wake Up Call",
    "A Hundred and Ten Percent",
    "Right Off the Bat",
    "On Cloud Nine",
    "Drawing a Blank",
    "Shot In the Dark",
    "Love Birds",
    "Raining Cats and Dogs",
    "Back To the Drawing Board",
    "A Day Late and a Dollar Short",
    "Heads Up",
    "Knock Your Socks Off",
    "My Cup of Tea",
    "In a Pickle",
    "Under the Weather",
    "Let Her Rip",
    "Wouldn't Harm a Fly",
    "Burst Your Bubble",
    "Fool's Gold",
    "A Hair’s Breadth",
    "A Lone Wolf",
    "Jaws of Death",
    "Son of a Gun",
    "Elvis Has Left The Building",
    "What Am I, Chopped Liver?",
    "A Leg Up",
    "If You Can't Stand the Heat, Get Out of the Kitchen",
    "A Lot on One’s Plate",
    "Wouldn't Harm a Fly",
    "A Cold Day in Hell",
    "Eat My Hat",
    "Not the Sharpest Tool in the Shed",
    "Elephant in the Room",
    "Hard Pill to Swallow",
    "A Dog in the Manger",
    "Roll With the Punches",
    "Quick and Dirty",
    "Man of Few Words",
    "Ugly Duckling",
    "Mouth-watering",
    "Don't Look a Gift Horse In The Mouth",
    "Cry Over Spilt Milk",
    "On the Ropes",
    "Lickety Split",
    "Down For The Count",
    "Let Her Rip",
    "Give a Man a Fish",
    "Two Down, One to Go",
    "It's Not All It's Cracked Up To Be",
    "Par For the Course",
    "Flea Market",
    "Jig Is Up",
    "Burst Your Bubble",
    "Love Birds",
    "In a Pickle",
    "It's Not Brain Surgery",
    "Short End of the Stick",
    "Tough It Out",
    "On the Same Page",
    "Hands Down",
    "Scot-free",
    "Top Drawer",
    "Under Your Nose",
    "A Home Bird",
    "Mountain Out of a Molehill",
    "Greased Lightning",
    "A Day Late and a Dollar Short",
    "Needle In a Haystack",
    "Fish Out Of Water",
    "High And Dry",
    "Swinging For the Fences",
    "Talk the Talk"
  ];

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <h1 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">
            {bannerPhrases[Math.floor(Math.random() * bannerPhrases.length)]}  <span className="text-color-primary">Timothy</span>
            </h1>
            <div className="container-xs">
              <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
              <span role="img" aria-label="sunglasses">😎</span> Just someone online.
                </p>
              <div className="reveal-from-bottom" data-reveal-delay="600">
                <ButtonGroup>
                  <Button tag="a" color="dark" wideMobile>
                    <Link to="Email">Email</Link>
                    </Button>
                  <Button tag="a" color="dark" wideMobile>
                    <Link to="Resume">Resume</Link>
                    </Button>
                  {/* <Button tag="a" color="secondary" wideMobile href="https://www.linkedin.com/in/thinh-le/">
                    Linkedin
                  </Button>
                  <Button tag="a" color="light" wideMobile href="https://github.com/TimothyLe/">
                    Github
                  </Button> */}
                </ButtonGroup>
              </div>
            </div>
          </div>
          <div className="hero-figure reveal-from-bottom illustration-element-01" data-reveal-value="20px" data-reveal-delay="800">
            <a
              data-video="https://player.vimeo.com/video/333832098"
              href="#0"
              aria-controls="video-modal"
              onClick={openModal}
            >
              <Image
                className="has-shadow"
                src={require('./../../assets/images/banner.jpg')}
                alt="Hero"
                width={896}
                height={504} />
            </a>
          </div>
          <Modal
            id="video-modal"
            show={videoModalActive}
            handleClose={closeModal}
            video="https://player.vimeo.com/video/333832098"
            videoTag="iframe" />
        </div>
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;